import { Boolean, Record } from 'runtypes';

export const TaskExtrasRunType = Record({
	userHasWriteAccessToTheTask: Boolean,
});
